import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TabModule } from '../tab/tab.module';
import { TabHeadersComponent } from './tab-headers.component';

@NgModule({
  imports: [CommonModule, TabModule],
  declarations: [TabHeadersComponent],
  exports: [TabHeadersComponent]
})
export class TabHeadersModule {}
